import { useState } from "react";

export function useHistoryDrawer() {
  const [isOpen, setIsOpen] = useState(false);

  function handleOpen() {
    setIsOpen(true);
  }

  function handleClose() {
    setIsOpen(false);
  }

  return {
    isOpen,
    handleOpen,
    handleClose,
  };
}
